<template>
  <div>
    <list-search-box v-model="form" :is-customer-contract-num="true" :is-show-contract-time="true" :is-show-region-business="true" @submit="doSearches" />
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="date" label="操作" width="90" align="left" fixed="left">
          <template v-slot="{row}">
            <el-button v-if="row.contractType !== '国际备件下单'" type="text" @click="createNewContract(row)">
              生成新合同
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称" align="left" fixed="left" min-width="220">
          <template v-slot="{row}">
            <el-button class="el-btn-text-left" type="text" @click="goDetails(row)">
              {{ row.projectName }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="contractNum" label="合同编号" align="left" min-width="140" />
        <el-table-column prop="erpOrderNum" label="ERP订单号" align="left" min-width="140" />
        <el-table-column prop="departmentName" label="部门" align="left" />
        <el-table-column prop="regionName" label="区域" align="left" min-width="60" />
        <el-table-column prop="createTime" label="合同时间" align="left" min-width="140" />
        <el-table-column prop="orderTime" label="下单时间" align="left" min-width="140" />
        <el-table-column label="现销/赊销" align="left" min-width="80">
          <template v-slot="{row}">
            <span v-if="row.salesType === 1">现销</span>
            <span v-else-if="row.salesType === 2">赊销</span>
            <span v-else-if="row.salesType === 3">LC</span>
          </template>
        </el-table-column>
        <el-table-column label="分配比例" align="right" header-align="left" min-width="100">
          <template v-slot="{row}">
            <span>
              {{ row.assignRatio }}%
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="regionBusinessCommissioner" label="商务" align="left" width="100" />
        <el-table-column prop="salesManName" label="外销" align="left" width="70" />
        <!--<el-table-column prop="date" label="打印合同" width="100" align="left">-->
        <!--<template v-slot="{row}">-->
        <!--<el-button type="text">打印</el-button>-->
        <!--</template>-->
        <!--</el-table-column>-->
        <!--<el-table-column prop="date" label="签章" width="70" align="left">-->
        <!--<template v-slot="{row}">-->
        <!--<el-button type="text">签章</el-button>-->
        <!--</template>-->
        <!--</el-table-column>-->
        <el-table-column prop="date" label="合同附件" width="80" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button type="text" @click="showFile(row)">
              操作
            </el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="isOrderAutoPassing" label="是否自动化" align="left" width="90">
          <template v-slot="{row}">
            <span>{{ row.isOrderAutoPassing?'是':'否' }}</span>
          </template>
        </el-table-column> -->
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
      <contract-file-dialog ref="fileDialog" />
    </div>
  </div>
</template>
<script type="es6">
import listSearchBox from './listSearchBox';
import contractFileDialog from '../contract/contractFileDialog';
import { getOrdersContractList, createNewContract } from '@/API';
import { numDiv, MathMulti } from '../../../libs/util';
import dayjs from 'dayjs';
import { buildCreateContractComplianceRequest, checkExportCompliance, isDomesticContract } from '@/libs/exportCompliance';
export default {
  data () {
    return {
      form: {
        projectName: '',
        contractNum: '',
        distributorName: '',
        salesManName: '',
        departmentName: '',
        regionName: '',
        tabType: 3,
        salesType: '0',
        createBeginTime: '',
        createEndTime: '',
        startDistributionRatio: 0,
        endDistributionRatio: 100,
        startAdvanceCharge: '',
        endAdvanceCharge: 100,
        customerContractNum: '',
        regionBusinessCommissioner: ''
      },
      tableData: [],
      tableLoading: false,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }

    };
  },
  components: {
    listSearchBox,
    contractFileDialog
  },
  computed: {},
  methods: {
    doSearch (resolve) {
      this.tableLoading = true;
      getOrdersContractList({
        ...this.form,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        if (resolve) resolve();
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        }
      }).catch(() => {
        if (resolve) resolve();
        this.tableLoading = false;
      });
    },
    doSearches (data, cab) {
      this.page.currentPage = 1;
      this.doSearch();
      cab(false);
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },
    showFile (row) {
      this.$refs.fileDialog.showFile(row.id);
    },
    // createNewContract (row) {
    //   this.tableLoading = true;
    //   createNewContract(row.id).then((res) => {
    //     this.tableLoading = false;
    //     let json = res.data;
    //     if (json.status === '200') {
    //       this.doSearch();
    //     }
    //   }).catch(() => {
    //     this.tableLoading = false;
    //   });
    // },
    async createNewContract (row) {
      this.tableLoading = true;
      if (isDomesticContract(row)) {
        let request;
        try {
          request = await buildCreateContractComplianceRequest(row);
        } catch (error) {
          this.$message.error(error.message);
          this.tableLoading = false;
          return;
        }
        const decision = await checkExportCompliance(this, request);
        if (!decision.allowBusiness) {
          this.tableLoading = false;
          return;
        }
      }
      createNewContract(row.id).then((res) => {
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          if (row.isOrderAdminCreate) {
            if (row.contractType !== '国际业务下单' && row.contractType !== '国际分销下单') {
              this.$router.push({
                name: 'orderPersionContractHandledraftsDomestic',
                params: {
                  contractNum: json.data
                }
              });
            } else {
              this.$router.push({
                name: 'orderPersionContractHandledraftsInternational',
                params: {
                  contractNum: json.data
                }
              });
            }
          } else {
            if (row.contractType === '国际业务下单' || row.contractType === '国际分销下单') {
              this.$router.push({
                'name': 'orderPersionContractHandlerInternational',
                params: {
                  contractNum: json.data
                },
                query: { isShowInternationalService: row.civilInternational ? row.civilInternational : '0' }
              });
            } else if (row.contractType === '服务订单') {
              this.$router.push({
                'name': 'orderPersionContractHandlerService',
                params: {
                  contractNum: json.data
                }
              });
            } else {
              this.$router.push({
                'name': 'orderPersionContractHandlerDomestic',
                params: {
                  contractNum: json.data
                }
              });
            }
          }
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    proportion (row) {
      let num = 0;
      if (row.contractSum === 0) {
        num = 0;
      } else {
        num = MathMulti(numDiv(row.assignAll, row.contractSum), 100);
      }
      return Number(num) !== 0 ? Number(num).toFixed(2) : 0;
    },
    goDetails (row) {
      if (row.contractType === '国际业务下单' || row.contractType === '国际分销下单') {
        this.$router.push({ name: 'businessDetails', params: { contractNum: row.contractNum }, query: { id: row.id, isShowInternationalService: row.civilInternational ? row.civilInternational : '0' } });
      } else if (row.contractType === '国际备件下单') {
        this.$router.push({ name: 'businessPartDetails', params: { contractNum: row.contractNum }, query: { id: row.id, isShowInternationalService: row.civilInternational ? row.civilInternational : '0' } });
      } else {
        this.$router.push({ name: 'orderPersionContractInfo', params: { contractNum: row.contractNum }, query: { id: row.id, isdisabled: true, transact: '3' } });
      }
    },
    setBeginTime () {
      const date = new Date();
      date.setMonth(0);
      date.setDate(1);
      this.form.createBeginTime = dayjs(date).format('YYYY-MM-DD');
    }
  },
  mounted () {
    // this.setBeginTime();
    this.doSearch();
  }
};
</script>
